import React from 'react'
import AdjustBalance from './AdjustBalance'
import { CompanyBalanceData } from '../../../../../services/api/companies'
import { Button, Descriptions, Modal, Space, Typography } from 'antd'
import { DollarCircleOutlined } from '@ant-design/icons'
import { displayAmount } from '../../../../../utils/formatter'

const { Text } = Typography
const { Item } = Descriptions
type Props = {
  companyId: string
  balance: CompanyBalanceData

  setIsFormVisible: (visibility: boolean) => void
  isFormVisible: boolean
  onBalanceAdjust: () => void
}

export const View: React.FunctionComponent<Props> = ({
  companyId,
  balance,

  isFormVisible,
  setIsFormVisible,
  onBalanceAdjust,
}) => {
  return (
    <>
      <Descriptions bordered size="small" column={1}>
        <Item label="Баланс компании">
          <Space size={20}>
            <Text>
              {displayAmount(balance.amount)} {balance.currency}
            </Text>
            <Button type="primary" onClick={() => setIsFormVisible(true)}>
              <DollarCircleOutlined /> Пополнить баланс
            </Button>
          </Space>
        </Item>
      </Descriptions>

      <Modal
        visible={isFormVisible}
        title="Пополнить баланс"
        onCancel={() => setIsFormVisible(false)}
        footer={false}
        destroyOnClose
      >
        <AdjustBalance companyId={companyId} onSuccess={onBalanceAdjust} />
      </Modal>
    </>
  )
}
